import React from "react";
import PropTypes from "prop-types";

import { css } from "glamor";

const baseStyles = {
    display: "block",
    textTransform: "capitalize",
};

const styles = [
    css({
        ...baseStyles,
        backgroundColor: "#fafafa",
        border: "1px solid #e8e8e8",
        borderLeft: "0px",
        borderRight: "0px",
        fontWeight: "bold",
        marginBottom: "10px",
        padding: "6px 24px",
    }),
    css({
        ...baseStyles,
        backgroundColor: "rgba(0, 174, 239, 0.15)",
        borderRadius: "5px",
        fontWeight: 500,
        padding: "6px 30px",
    }),
];

const Heading = ({ children, level, ...props }) => (
    <div {...styles[level]} {...props}>
        {children}
    </div>
);

Heading.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.node,
        PropTypes.arrayOf(PropTypes.node),
    ]).isRequired,
    level: PropTypes.number,
};

Heading.defaultProps = {
    level: 0,
};

export default Heading;
